import { makeStyles } from '@barracuda-internal/bds-core'

export default makeStyles(theme => ({
  wrapper: {
    flexGrow: 1,
    height: '100%'
  }
}))
